import { createAsyncTypes } from 'utils/ActionCreator'

import { LEVEL_VALUES } from 'containers/AwarenessCenter/constants'

const typeKey = 'AwarenessCenter/Campaigns/CampaignReport'

export const RESEND_TRAINING_REQUEST_ASYNC = createAsyncTypes('RESEND_TRAINING_REQUEST', typeKey)
export const EMERGENCY_STOP_REQUEST_ASYNC = createAsyncTypes('EMERGENCY_STOP_REQUEST', typeKey)
export const GET_REPORT_PARTICIPANTS_LIST_ASYNC = createAsyncTypes(
  'GET_REPORT_PARTICIPANTS_LIST',
  typeKey
)
export const GET_REPORT_SUMMARY_ASYNC = createAsyncTypes('GET_REPORT_SUMMARY', typeKey)
export const SAVE_DRAFT_ASYNC = createAsyncTypes('SAVE_DRAFT', typeKey)
export const GET_CAMPAIGN_DATA_ASYNC = createAsyncTypes('GET_CAMPAIGN_DATA', typeKey)
export const SHARE_CSV_REPORT_ASYNC = createAsyncTypes('SHARE_CSV_REPORT', typeKey)
export const SAVE_MANUAL_TRAINING_RESULTS_ASYNC = createAsyncTypes(
  'SAVE_MANUAL_TRAINING_RESULTS',
  typeKey
)

export const SEGMENT_FILTER_CHANGE = `${typeKey}/SEGMENT_FILTER_CHANGE`
export const SEARCH_CHANGE = `${typeKey}/SEARCH_CHANGE`
export const CHANGE_TABLE_FILTERS = `${typeKey}/CHANGE_TABLE_FILTERS`
export const CLEAR_TABLE_FILTERS = `${typeKey}/CLEAR_TABLE_FILTERS`
export const RESET_REPORT = `${typeKey}/RESET_REPORT`
export const CHANGE_SELECTION_DATA = `${typeKey}/CHANGE_SELECTION_DATA`
export const SET_TABLE_FILTERS = `${typeKey}/SET_TABLE_FILTERS`
export const RESET_SELECTION_DATA = `${typeKey}/RESET_SELECTION_DATA`
export const CHANGE_TRAINING_RESULTS_MODAL_STATUS = `${typeKey}/CHANGE_TRAINING_RESULTS_MODAL_STATUS`
export const CHANGE_TRAINING_RESULTS_MODAL_POSTPONED_DATE = `${typeKey}/CHANGE_TRAINING_RESULTS_MODAL_POSTPONED_DATE`

export const CAMPAIGN_RESULT_STATUSES = {
  REPORTED: 'reported',
  CLICKED: 'clicked',
  ENTERED_DATA: 'entered_data',
  OPENED: 'opened',
  UNOPENED: 'unopened',
  NOT_DELIVERED: 'not_delivered',
  NOT_AVAILABLE: 'not_available',
  POSTPONED: 'postponed',
  MANUALLY_TRAINED: 'manually_trained',
  TRAINED: 'trained',
  NOT_TRAINED: 'not_trained',
  TRAINING_BLANK_LEGACY: 'training_blank_legacy',
}

export const TRAINING_STATUS_OPTIONS = [
  { label: 'Reported', value: CAMPAIGN_RESULT_STATUSES.REPORTED },
  { label: 'Clicked', value: CAMPAIGN_RESULT_STATUSES.CLICKED },
  { label: 'Entered details', value: CAMPAIGN_RESULT_STATUSES.ENTERED_DATA },
  { label: 'Opened', value: CAMPAIGN_RESULT_STATUSES.OPENED },
  { label: 'Unopened', value: CAMPAIGN_RESULT_STATUSES.UNOPENED },
  { label: 'Postponed', value: CAMPAIGN_RESULT_STATUSES.POSTPONED },
  { label: 'Trained', value: CAMPAIGN_RESULT_STATUSES.TRAINED },
  { label: 'Not trained', value: CAMPAIGN_RESULT_STATUSES.NOT_TRAINED },
  { label: 'Not delivered', value: CAMPAIGN_RESULT_STATUSES.NOT_DELIVERED },
  { label: 'Manually trained', value: CAMPAIGN_RESULT_STATUSES.MANUALLY_TRAINED },
  { label: 'N/A', value: CAMPAIGN_RESULT_STATUSES.NOT_AVAILABLE },
  { label: 'Blank', value: CAMPAIGN_RESULT_STATUSES.TRAINING_BLANK_LEGACY },
]

export const TRAINING_RESULT_OPTIONS = [
  { label: '0', value: 0 },
  { label: '20', value: 20 },
  { label: '40', value: 40 },
  { label: '60', value: 60 },
  { label: '80', value: 80 },
  { label: '100', value: 100 },
]

export const PARTICIPANTS_LEVEL_OPTIONS = [
  { label: 'Beginner', value: LEVEL_VALUES.BEGINNER_LEVEL },
  { label: 'Mid', value: LEVEL_VALUES.MID_LEVEL },
  { label: 'Expert', value: LEVEL_VALUES.EXPERT_LEVEL },
]

export const SHARE_ACTIONS = {
  DOWNLOAD: 'download',
  SHARE_WIA_EMAIL: 'share-via-email',
}

export const CAMPAIGN_TRAINING_RESULTS_MODAL_STATUS = {
  TRAINED: 'trained',
  POSTPONED: 'postponed',
  REVERT: 'revert',
}

export const CAMPAIGN_TRAINING_RESULTS_MODAL_STATUS_OPTIONS = [
  { label: 'Trained', value: CAMPAIGN_TRAINING_RESULTS_MODAL_STATUS.TRAINED },
  { label: 'Postponed', value: CAMPAIGN_TRAINING_RESULTS_MODAL_STATUS.POSTPONED },
  { label: 'Revert', value: CAMPAIGN_TRAINING_RESULTS_MODAL_STATUS.REVERT },
]
export const PER_PAGE = 25
export const CHARTS_MARGIN = 40
export const CHARTS_SIDE_PADDING = 32
export const HOURS_TO_START_CAMPAIGN = 1
export const END_DATE_INTERVAL = 14
export const MAX_DOWNLOAD_CSV_COUNT = 5000
